import EventEmitter from 'events';
import { durationInSeconds } from 'libs/duration';
import { isNoise } from 'libs/is-noise';
import ProjectStateHandler from './project-state-handler';
export default class RecognitionHandler extends ProjectStateHandler {
    constructor(messageStream) {
        super(messageStream, 'prestart');
        this.speakersSet = new Set();
        this.emitter = new EventEmitter();
        this.handleRecognitionStarted = (message) => {
            this.emitRecognitionEvent('transcription-started', message.id, message.source);
            this.updateStatus('waiting-for-words');
        };
        this.handleASRMsg = (message) => {
            var _a, _b, _c, _d;
            const { data } = message;
            const hasDraft = data.draft !== null && data.draft !== undefined;
            const hasWord = data.word !== null;
            if (hasDraft) {
                const rawDraft = data.draft;
                const draftArray = Array.isArray(rawDraft) ? rawDraft : [rawDraft];
                const segments = draftArray.map((item) => {
                    var _a;
                    return {
                        text: (_a = item.text) !== null && _a !== void 0 ? _a : '',
                        begin: durationInSeconds(item.begin),
                        end: durationInSeconds(item.end),
                    };
                });
                this.emitRecognitionEvent('draft', segments, message);
            }
            if (hasWord) {
                const begin = durationInSeconds(data.word.begin);
                const end = durationInSeconds(data.word.end);
                const { text } = data.word;
                const isPhraseNoise = isNoise(text);
                this.emitRecognitionEvent('word', {
                    begin, end, text, isNoise: isPhraseNoise,
                }, message);
                if (this.status === 'waiting-for-words' && !isPhraseNoise) {
                    this.updateStatus('running');
                }
            }
            else if (data.speakerChangePoint !== null) { // Speaker
                this.emitRecognitionEvent('speaker', data.speakerChangePoint.speakerId, message);
                this.updateStatus('running');
                this.speakersSet.add(data.speakerChangePoint.speakerId);
            }
            else if (data.speakerData !== null) {
                this.emitRecognitionEvent('speaker-id', message.data.speakerData.xmlSpeaker, message);
            }
            else if (data.heading !== null && data.heading !== undefined) {
                const headingName = (_b = (_a = data.heading) === null || _a === void 0 ? void 0 : _a.heading) !== null && _b !== void 0 ? _b : '';
                const headingLevel = (_d = (_c = data.heading) === null || _c === void 0 ? void 0 : _c.level) !== null && _d !== void 0 ? _d : 0;
                this.emitRecognitionEvent('heading', {
                    name: headingName,
                    id: null,
                    tags: [],
                    isChapter: headingLevel <= 1,
                }, message);
                this.updateStatus('running');
            }
        };
        this.addStreamListener('TranscriptionStreaming', 'Started', this.handleRecognitionStarted);
        this.addStreamListener('TranscriptionStreaming', 'Progress', this.handleASRMsg);
    }
    addRecognitionListener(event, listener) {
        this.emitter.on(event, listener);
    }
    removeRecognitionListener(event, listener) {
        this.emitter.off(event, listener);
    }
    emitRecognitionEvent(event, ...args) {
        this.emitter.emit(event, ...args);
    }
}
